import React, { useState } from "react";
import ArtistImages from "./ArtistImages";
import FileUpload from "components/FileUpload";

interface ArtistPortfolioProps {
    artistId: string;
    isVisitor: boolean;
}

const ArtistPortfolio: React.FC<ArtistPortfolioProps> = ({ artistId, isVisitor }) => {
    const [refreshKey, setRefreshKey] = useState(0); // State to trigger re-render

    const handleUploadSuccess = () => {
        setRefreshKey((prevKey) => prevKey + 1); // Increment refreshKey to trigger re-fetch
    };

    return (
        <div className="min-h-screen bg-gray-100 relative flex flex-col justify-between">
            {/* Main Content */}
            <div className="container mx-auto py-8 flex-grow">
                <h1 className="text-4xl font-bold text-center text-gray-800 mb-8">Portfolio</h1>
                <ArtistImages artistId={artistId} isVisitor={isVisitor} refreshKey={refreshKey} />
            </div>

            {/* Bottom FileUpload */}
            {!isVisitor && (
                <div className="container mx-auto py-4">
                    <FileUpload onUploadSuccess={handleUploadSuccess} />
                </div>
            )}
        </div>
    );
};

export default ArtistPortfolio;